<template>
    <div class="field singleline" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
        </div>
        <div class="input">
            <input type="hidden" :name="name" :value="newValue" :required="required">
            <v-select
                :value="newValue"
                :placeholder="placeholder"
                :clearable="false"
                :searchable="false"
                :options="options"
                @input="setAndEmitValue"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            required: true
        },
    },

    computed: {
        newValue() {
            return this.value;
        }
    },

    methods: {
        setAndEmitValue(val) {
            this.$emit('update:value', val);
        },
    }
}
</script>
